import type { ReactNode } from 'react'
import logo from '../assets/alelo-logo.svg'
import styles from './RangoAuthLayout.module.css'

export const authLayoutStyles = styles

/**
 * Card Rango DS das páginas de entrada da SPA (fora do Universal Login),
 * igual ao `AleloLayout` das telas ACUL: logo, título e conteúdo.
 */
export function RangoAuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className={styles.page}>
      <div className={styles.column}>
        <img
          src={logo}
          alt="Alelo"
          className={styles.logo}
          width={120}
          height={83}
          decoding="async"
        />
        {children}
      </div>
    </main>
  )
}
